// Gespeichert wie die Filter der ambulanten Psychotherapie im localStorage,
// unter eigenem Schluessel, damit sich beide Uebersichten nicht stoeren.
const STORAGE_KEY = 'clinicFilterData';

export const EMPTY_CLINIC_FILTERS = {
  TypeOfClinic: '',
  TreatmentSetting: '',
  TherapyProcedures: [],
  DisordersMainFocus: [],
  DisordersNotExcluded: [],
  Treatments: [],
  ClinicEligble: '',
  LegallyInsuredPatientsTreated: '',
  Accompanying: [],
};

// "Akut & Reha" bzw. "voll- und teilstationär" erfuellen beide Einzelwerte.
const MATCHING_VALUES = {
  TypeOfClinic: {
    acute: ['acute', 'mixed'],
    reha: ['reha', 'mixed'],
    mixed: ['mixed'],
  },
  TreatmentSetting: {
    inpatient: ['inpatient', 'both'],
    daycare: ['daycare', 'both'],
    both: ['both'],
  },
};

const ANY_OF_FIELDS = ['TherapyProcedures', 'DisordersMainFocus', 'Treatments'];
const BOOL_FIELDS = ['ClinicEligble', 'LegallyInsuredPatientsTreated'];

const isActive = (value) =>
  Array.isArray(value) ? value.length > 0 : value !== '' && value != null;

const includesAny = (values, selected) =>
  Array.isArray(values) && values.some((value) => selected.includes(value));

const CLINIC_FILTER_PREDICATES = [
  (row, filters) =>
    Object.keys(MATCHING_VALUES).every(
      (key) =>
        !isActive(filters[key]) ||
        (MATCHING_VALUES[key][filters[key]] || [filters[key]]).includes(
          row[key],
        ),
    ),
  (row, filters) =>
    ANY_OF_FIELDS.every(
      (key) => !isActive(filters[key]) || includesAny(row[key], filters[key]),
    ),
  (row, filters) =>
    !isActive(filters.DisordersNotExcluded) ||
    !includesAny(row.DisordersExclusion, filters.DisordersNotExcluded),
  (row, filters) =>
    BOOL_FIELDS.every(
      (key) =>
        !isActive(filters[key]) || row[key] === (filters[key] === 'true'),
    ),
  (row, filters) =>
    !isActive(filters.Accompanying) ||
    filters.Accompanying.some((key) => row[key] === true),
];

export const filterClinics = (rows, filters) =>
  rows.filter((row) =>
    CLINIC_FILTER_PREDICATES.every((matches) => matches(row, filters)),
  );

export const hasActiveClinicFilters = (filters) =>
  Object.keys(EMPTY_CLINIC_FILTERS).some((key) => isActive(filters[key]));

export const loadClinicFilters = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (!stored) return { ...EMPTY_CLINIC_FILTERS };
  try {
    return { ...EMPTY_CLINIC_FILTERS, ...JSON.parse(stored) };
  } catch (e) {
    console.warn(
      'Gespeicherte Klinik-Filter sind ungültig und werden verworfen.',
      e,
    );
    localStorage.removeItem(STORAGE_KEY);
    return { ...EMPTY_CLINIC_FILTERS };
  }
};

export const saveClinicFilters = (filters) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
};

export const clearStoredClinicFilters = () => {
  localStorage.removeItem(STORAGE_KEY);
};
